import React, {useState} from 'react'
import i18n from 'i18next'
import Headline from '#components/a/Headline'
import Loading from '#components/a/Loading'
import {LinkWithArrow} from '#components/m/MeineOrganisation/LinkWithArrow'
import PageHeader from '#components/m/PageHeader'
import {AusbilderRow} from '#components/o/MeineOrganisation/AusbilderRow'
import {AddAusbilderModal} from '#components/o/MeineOrganisation/AddAusbilderModal'
import {HeaderRow} from '#components/m/HeaderRow'
import {useUserAusbilderListe} from '#hooks/store/useUserAusbilderListe'
import Pagination from '#components/m/Pagination'
import Text from '#components/a/Text'

export function MeineAusbilder() {
  const {ausbilderListe, isLoading} = useUserAusbilderListe()
  const options = [{displayName: 'Name'}, {displayName: 'Markt'}, {displayName: 'Abteilungen'}]

  const [visibleAusbilder, setVisibleAusbilder] = useState([])
  const scroll = (skip, take) => {
    setVisibleAusbilder(ausbilderListe.slice(skip, skip + take))
  }

  return (
    <section className="meineausbilder">
      <PageHeader
        headline={
          <div>
            <Headline importance={1} modifier="section" text={i18n.t('meine_ausbilder_headline')} />
            <LinkWithArrow to="/meineorganisation/meineazubis" text={i18n.t('meine_organisation_to_azubis')} />
          </div>
        }
        button={<AddAusbilderModal ausbilderListe={ausbilderListe} ausbilderListeIsLoading={isLoading} />}
      />
      <Pagination data={ausbilderListe} scrollCallback={scroll} />
      {ausbilderListe.length > 0 && (
        <table>
          <thead>
            <tr>
              <HeaderRow headerOptions={options} />
            </tr>
          </thead>
          <tbody>
            {visibleAusbilder.map(a => (
              <AusbilderRow key={a.id} ausbilder={a} />
            ))}
          </tbody>
        </table>
      )}
      {!isLoading && ausbilderListe?.length === 0 && (
        <Text data-testid="ausbilderliste-empty" text={i18n.t('no_userausbilder_found')} />
      )}
      <div className="loading_wrapper">{isLoading && <Loading />}</div>
    </section>
  )
}

export default MeineAusbilder
